/**
 * Renderer for `uiStore` toasts. Screens have been pushing these since the
 * capture flows landed; until now nothing displayed them. Sits above the
 * bottom chrome, announces politely, and never traps focus.
 */
import { T } from '@/components/primitives';
import { useUiStore } from '@kapture/client-core';

const TONE_COLOR: Record<string, string> = {
  good: T.good,
  warn: T.warn,
  danger: T.danger,
  neutral: T.textDim,
};

export function Toasts() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);

  return (
    <div
      aria-live="polite"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 96,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
        pointerEvents: 'none',
        zIndex: 60,
        padding: '0 16px',
      }}
    >
      {toasts.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => dismiss(t.id)}
          style={{
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            maxWidth: 360,
            padding: '9px 14px',
            borderRadius: T.r2,
            background: T.ink,
            color: T.hudInk,
            border: `1px solid ${T.hudLine}`,
            boxShadow: T.sh2,
            fontFamily: T.font,
            fontSize: 12.5,
            fontWeight: 600,
            cursor: 'pointer',
            textAlign: 'left',
          }}
        >
          <span
            aria-hidden
            style={{
              width: 7,
              height: 7,
              borderRadius: 4,
              flexShrink: 0,
              background: TONE_COLOR[t.tone] ?? T.textDim,
            }}
          />
          {t.message}
        </button>
      ))}
    </div>
  );
}
